module.exports = __webpack_public_path__ + "static/assets/2296e0b6e814962ecb2db9a0fc3d8634.png";